export default __webpack_public_path__ + "static/ism-home-mobile3-011c5b4e0a1b458892c0f54103c401ea.png";